import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ogni cambio pagina riparte dall'inizio, non dalla posizione precedente.
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
